import React, { useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";

const SalInvoiceCreate = () => {
  const navigate = useNavigate();
  const { id } = useParams();
  useEffect(() => {
    if (id) {
      navigate(`/SaleInvoice/${id}`);
    }
  }, []);
};

export default SalInvoiceCreate;
